import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41fab900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-ml-xl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "onecbm-welcome" }, "Welcome to OneCBM", -1 /* HOISTED */))
const _hoisted_3 = { class: "text-h6 q-ml-md" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { "data-test": "site-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAssignedCountriesAndSites, (assignedCountryAndSites) => {
      return (_openBlock(), _createElementBlock("div", { key: assignedCountryAndSites }, [
        _createVNode(_component_q_icon, {
          outline: "",
          name: "o_factory",
          style: {"color":"#96a3bd"},
          class: "site-icon"
        }),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getCountryAndSite(assignedCountryAndSites.countryAndBloc)), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assignedCountryAndSites.sitesAndRoles, (siteAndRole) => {
            return (_openBlock(), _createElementBlock("div", {
              key: siteAndRole,
              "data-test": "site",
              class: "site-card-main animate fadeInLeft"
            }, [
              _createVNode(_component_q_card, {
                class: "q-ma-md fpsoCard site-card",
                onClick: ($event: any) => (
              _ctx.setSelectedSite(
                assignedCountryAndSites.countryAndBloc,
                siteAndRole.site
              )
            )
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "site-image",
                    src: 
                require('../../assets/fpso/' +
                  siteAndRole.site.toLowerCase() +
                  '.jpg').default
              ,
                    alt: siteAndRole.site,
                    width: "208",
                    height: "120"
                  }, null, 8 /* PROPS */, _hoisted_5),
                  _createVNode(_component_q_card_section, { class: "site-card-title" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(siteAndRole.site.toUpperCase()), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}